export default __webpack_public_path__ + "static/media/CT_Logo.246e0cb5.png";